import { localize } from '../i18n';

// Broad medication-use tips; source evidence is recorded in the international audit.
export function getInternationalMedicationTips() {
    return [
        { icon: '📖', text: localize('약을 사용하기 전에 라벨과 복용 지시를 확인하세요.') },
        { icon: '⏰', text: localize('알림 시간은 처방전이나 약사의 복용 지시에 맞춰 설정하세요.') },
        { icon: '📝', text: localize('의사나 약사에게 복용 중인 약과 영양제 목록을 알려주세요.') },
        { icon: '💊', text: localize('알약을 부수거나 캡슐을 열기 전에는 약사에게 확인하세요.') },
        { icon: '🌡️', text: localize('약마다 보관 조건이 달라요. 포장에 적힌 보관 방법을 확인하세요.') },
        { icon: '❓', text: localize('복용법이 헷갈리면 추측하지 말고 의사나 약사에게 물어보세요.') },
    ];
}
